import '../App.css';
import {List, ListItem, Box, Button} from '@mui/material/';
import TextInput from '../components/TextInput';
import SingleSelect from '../components/SingleSelect';
import MultiDropdown from '../components/MultiDropdown';
import MultiSelect from '../components/MultiSelect';
import SortableList from '../components/SortableList';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import languages from './../json/languages'
import axios from "axios";
import ImageUpload from '../components/ImageUpload';
import DayTimePicker from '../components/DayTimePicker';
import Scale from '../components/Scale';
import moment from 'moment';
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";

function UpdateSchedule() {
    const [error, setError] = useState('')

    const validationSchema = Yup.object().shape({
        scheduleQuestion: Yup.array().of(
            Yup.object().shape({
                name: Yup.string(),
                count: Yup.number(),
                slots: Yup.array().of(Yup.object().shape({
                    time: Yup.string(),
                    timezone: Yup.string()}
                ))
            })).required('This question is required')
            .test('check-min-slots', '(Please add at least one slot)',
                function(value) {
                    let valid = false
                    value.map(day => (
                        day.slots.map(slot => {
                            if(slot.time!=='' && slot.timezone!=='' && slot.time !== undefined && slot.timezone !== undefined){
                                valid = true
                            }
                        })
                    ))
                    return valid
                })
            .test('check-valid-slots', '(Please correct the invalid slot)',
                function(value) {
                    let valid = true

                    value.map(day => (
                        day.slots.map(slot => {
                            if(slot.time === '' || slot.timezone === '' || slot.time === undefined || slot.timezone === undefined){
                                valid = false
                            }
                        })
                    ))
                    return valid
                }),
        });

    const { control, handleSubmit, formState: { errors }, setValue } = useForm({ mode: 'all', resolver: yupResolver(validationSchema)});

    const uploadSchedule = (data) => {
        axios.post(constants.serverURL + "updateMentorSchedule", {data},
            {
                withCredentials: true
            }).then(response => {
            window.location.href = constants.websiteURL + "#/main"
        }).catch((error) => {
            setError(error.request.responseText)
        })
    }

    return(
        <div>
            <MenuAppBar title="Mentor Survey" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                    <List>
                        <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                            <DayTimePicker
                                name={"scheduleQuestion"}
                                control={control}
                                setValue={setValue}
                                question={"The best days and time for me to mentor are..."}
                                helper={["Please add at least one 30 minutes slot on your desired day. You can add multiple slots.","This is a semester long experience with your mentee(s)."]}
                                required={true}
                                errors={errors.scheduleQuestion}/>
                        </ListItem>
                    </List>
                    <Button type='submit' className="m-form-button" variant="outlined" onClick={handleSubmit(uploadSchedule)}>Submit</Button>
                </Box>
            </form>
        </div>
    )
}

export default UpdateSchedule;